import api from '../axios.js'

// /v2.1/public/glossaries?category=general&key=on-process-settlement&language=id

/**
 * Get Glossaries
 * @param {Object} params - Axios request parameters
 * @param {String} params.category - Glossary category
 * @param {String} params.key - Glossary key
 * @param {String} params.language - Glossary language
 * @returns {Promise} - Axios response Promise
 */
export const getGlossaries = async (params) => {
	return await api.get('/v2.1/public/glossaries', { params })
}